import { ApiClient } from './client';

export function fetchEVData(client: ApiClient, campusId: string): Promise<any> {
  return client.get(`/ahiapi/${campusId}/campus/evChargers`);
}

export function fetchBatteryData(client: ApiClient, campusId: string): Promise<any> {
  return client.get(`/ahiapi/${campusId}/acBatteries`);
}

export function deleteEVOverride(client: ApiClient, gxId: string, groupId: string): Promise<any> {
  return client.delete(`/ahiapi/${gxId}/gridInterconnect/evChargerGroup/override/${groupId}`);
}

export function deleteEVGroup(client: ApiClient, gxId: string, groupId: string): Promise<any> {
  return client.delete(`/ahiapi/${gxId}/gridInterconnect/evChargerGroup/${groupId}`);
}

export function createEVOverride(client: ApiClient, gxId: string, body: unknown): Promise<any> {
  return client.post(`/ahiapi/${gxId}/gridInterconnect/evChargerGroup/override`, body);
}

export function editEVGroup(client: ApiClient, gxId: string, body: unknown): Promise<any> {
  return client.post(`/ahiapi/${gxId}/gridInterconnect/evChargerGroup`, body);
}

export function updateAllocations(client: ApiClient, gxId: string, body: unknown): Promise<any> {
  return client.post(`/ahiapi/${gxId}/backupReservation`, body);
}
